// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  worldId: __t.string().name("world_id"),
  structureIndex: __t.u32().name("structure_index"),
  name: __t.string(),
  tier: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  radius: __t.f64(),
  ownerPlayerId: __t.option(__t.string()).name("owner_player_id"),
  goldPerTick: __t.u32().name("gold_per_tick"),
  manpowerPerTick: __t.u32().name("manpower_per_tick"),
  suppliesPerTick: __t.u32().name("supplies_per_tick"),
  updatedAt: __t.timestamp().name("updated_at"),
});
